<template>
  <DynamicFormHolder
    :is-dialog="isDialog"
    :form-name="formName"
    :steps-after-form="stepsAfterForm"
    :gtm-form-name="gtmFormName"
    :load-default-data="false"
    :steps-before="stepsBefore"
    :use-need-help="false"
  />
</template>

<script>
import { mapMutations } from 'vuex';
import dynamicForms from '@/mixins/dynamicForms';

export default {
  name: 'StaticFormHolder',
  mixins: [dynamicForms],
  props: {
    formName: {
      type: String,
      required: true
    },
    gtmFormName: {
      type: String,
      required: false
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    stepsBefore: {
      type: Array,
      required: false
    },
    stepsAfterForm: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.updateLoading({
      formName: this.formName,
      value: false
    });
  },
  mounted() {
    if (this.$route.query.dfn === this.formName) {
      this.updateRoute();
    }
  },
  methods: {
    ...mapMutations({ updateLoading: 'dynamicForms/updateLoading' })
  }
};
</script>
